import React from 'react';
import { View, TouchableHighlight, Platform, Dimensions } from 'react-native';

import { get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFInput, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { User_Types } from '@vfgroup-oneplatform/foundation/Utils/UserTypes.Enum';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { Images } from '../../../Themes';

import styles from './NewRecipient.Styles';

function NewRecipient({
  phone,
  isValid,
  showErrorText,
  mobileNumberRef,
  onPhoneChanged,
  maxLength,
  onContactListPress,
  iconName,
  theme,
  accounts,
}) {
  const isAccountsAvailable = _get(accounts, 'length', 0) > 0;
  return (
    <View>
      <VFText
        i18nKey="top_up_someone_else_new_recipient_title"
        style={styles.title(theme, isAccountsAvailable)}
      />
      <View style={styles.newRecipientContainer(theme, isAccountsAvailable)}>
        <VFInput
          label="top_up_someone_else_new_recipient_header_title"
          fontSize={18}
          value={phone}
          fieldRef={mobileNumberRef}
          helperText="top_up_someone_else_new_recipient_error_title"
          keyboardType="phone-pad"
          labelTextStyle={styles.label(theme)}
          containerStyle={styles.inputContainerStyle}
          textInputContainerStyle={styles.textInputContainerStyle}
          contentInset={{ label: Platform.OS == 'android' ? 1 : -1 }}
          baseColor={
            !isValid || showErrorText
              ? theme.colors.textInput.error.baseColor
              : theme.colors.textInput.default.baseColor
          }
          tintColor={
            !isValid || showErrorText
              ? theme.colors.textInput.error.baseColor
              : theme.colors.textInput.default.tintColor
          }
          textColor={theme.colors.textColorThree}
          showHelperText={!isValid}
          helperTextColor={
            !isValid || showErrorText
              ? theme.colors.textInput.error.helperText
              : theme.colors.textInput.default.helperTextColor
          }
          selectionColor={theme.colors.textInput.default.selectionColor}
          onChangeText={onPhoneChanged}
          maxLength={maxLength}
          inputAccessibilityLabel={FrameworkTestKeys.LoginPhoneTxt}
          helperAccessibilityLabel={FrameworkTestKeys.TextinputError}
        />

      </View>
    </View>
  );
}
NewRecipient.defaultProps = {
  theme: LightThemeColors,
  iconName: Images.icCallsContactsWhite,
};
NewRecipient.propTypes = {
  phone: PropTypes.string,
  onContactListPress: PropTypes.func,
  mobileNumberRef: PropTypes.string,
  maxLength: PropTypes.number,
  isValid: PropTypes.bool,
  showErrorText: PropTypes.bool,
  onPhoneChanged: PropTypes.func,
  iconName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  userType: PropTypes.oneOf(Object.values(User_Types)),
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.string,
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      phone: PropTypes.string,
    }),
  ),
};

export default withTheme(NewRecipient);
